import Vue from 'vue'
import Vuex from 'vuex'
import { login as apiLogin, getUserInfo, logout as apiLogout } from '@/api'
import { normalizeMenus, firstAccessiblePath } from '@/utils/menus'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      name: '',
      role: '供应商',
      avatar: ''
    },
    roles: [],       // 用户角色列表
    permissions: [], // 用户权限标识列表
    menus: [],       // 动态菜单
    isSuper: false,  // 未绑定角色的超级管理员（菜单不受权限限制）
    userInfoLoaded: false // 用户信息是否已拉取成功（守卫据此判断，不能用 permissions 是否为空判断——角色无权限时也是空）
  },
  getters: {
    hasPermission: (state) => (slug) => {
      return state.permissions.includes(slug)
    },
    // 侧边栏菜单：严格以接口返回为准，仅超管在接口异常时才用本地兜底菜单
    sidebarMenus: (state) => normalizeMenus(state.menus, state.isSuper),
    // 登录后/根路径的落地页：第一个有权限的菜单（角色没勾「首页数据」就不会进首页）
    firstAccessiblePath: (state) => firstAccessiblePath(state.menus, state.isSuper)
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    SET_MENUS(state, menus) {
      state.menus = menus
    },
    SET_IS_SUPER(state, isSuper) {
      state.isSuper = !!isSuper
    },
    SET_USER_INFO_LOADED(state, loaded) {
      state.userInfoLoaded = !!loaded
    }
  },
  actions: {
    login({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        apiLogin(credentials).then(res => {
          const { token, user } = res
          localStorage.setItem('supplier_token', token)
          commit('SET_USER', user)
          resolve(user)
        }).catch(err => {
          reject(err)
        })
      })
    },
    fetchUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          commit('SET_USER', {
            id: res.id,
            name: res.name || res.username,
            role: res.role || '供应商',
            avatar: res.avatar || ''
          })
          commit('SET_ROLES', res.roles || [])
          commit('SET_PERMISSIONS', res.permissions || [])
          commit('SET_MENUS', res.menus || [])
          commit('SET_IS_SUPER', res.is_super)
          commit('SET_USER_INFO_LOADED', true)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        apiLogout().catch(() => {})
        commit('SET_USER', { name: '', role: '', avatar: '' })
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        commit('SET_MENUS', [])
        commit('SET_IS_SUPER', false)
        commit('SET_USER_INFO_LOADED', false)
        localStorage.removeItem('supplier_token')
        resolve()
      })
    }
  }
})
